import Model from './Model'

export default class FoodSwap extends Model {
  resource() {
    return 'food-swaps'
  }
}
